<app-table [columns]="columns" [data]="companies" [settings]="settings" [loading]="loadingCompanies">
    <ng-template #field let-item="item">
        <a routerLink="/companies/{{item.id}}">{{ item.name }}</a>
    </ng-template>
</app-table>